import { createInstance, type i18n } from 'i18next';

import assistantTranslations from './translations';
import { TranslationOverrides } from './types';

// Create a dedicated i18n instance for the assistant package.
// Note: We intentionally do NOT call .use(initReactI18next) here because that
// would overwrite the host app's global react-i18next instance. Instead, the
// AIShellContextProvider wraps its tree with I18nextProvider to scope this instance.
const assistantI18n: i18n = createInstance();

assistantI18n.init({
  lng: 'en-US',
  fallbackLng: 'en-US',
  debug: false,

  resources: assistantTranslations,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },

  react: {
    useSuspense: false,
  },
});

/**
 * Update the assistant i18n instance with translation overrides
 *
 * @param overrides Translation overrides to merge with defaults
 */
export const updateAssistantTranslations = (overrides: TranslationOverrides = {}) => {
  const mergedResources: TranslationOverrides = { ...assistantTranslations };

  Object.keys(overrides).forEach((language) => {
    const existingResource = mergedResources[language];
    const overrideResource = overrides[language];

    if (existingResource && overrideResource) {
      mergedResources[language] = {
        ...existingResource,
        assistant: {
          ...((existingResource.assistant as any) || {}),
          ...((overrideResource.assistant as any) || {}),
        },
      };
    } else if (overrideResource) {
      mergedResources[language] = { ...overrideResource };
    }

    const assistantContent = (mergedResources[language] as any)?.assistant;
    if (assistantContent) {
      assistantI18n.addResourceBundle(language, 'assistant', assistantContent, true, true);
    }
  });
};

export { assistantI18n as i18n };
export default assistantI18n;
